import {
  Avatar,
  DatePicker,
  Input,
  InputNumber,
  Select,
  Tooltip,
  Upload,
  message, Radio,
} from 'antd';
import ScreenDrawer from 'components/ScreenDrawer';
// import Checkbox from 'antd/lib/checkbox/Checkbox';
// import { useChangeHandler } from 'hooks';
import moment from 'moment';
// import 'moment-timezone';
import React, { useEffect, useMemo, useRef, useState } from 'react';
// import InputMask from 'react-input-mask';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  createMediaCategory,
  fetchMediaCategories,
  modifyMediaCategory,
  setMediaCategory,
} from 'state/actions/mediaCategories';
import { regexDescription, regexInput } from 'utils/regex';
import { imgUrl } from 'utils/url';
import { log } from 'utils';
import './MediaForm.css';
import _ from 'underscore';
import './MediaForm.scss';
import { setMedia } from 'state/actions/media';
import { fetchScreens } from 'state/actions/screens';
import { ExportIcon, TrashIcon } from 'assets/icon/dynamic';
import CategoryDropdown from 'components/CategoryDropdown';
import ModalMediaCategoryForm from 'components/ModalMediaCategoryForm';
import dayjs from 'dayjs';
import { Option } from 'antd/lib/mentions';

function MediaFormLegacy({
  // media,
  // setMedia,
  action,
  days,
  setDays,
  dates,
  setDates,
  history,
  success,
  id,
  error,
  isEditing,
}) {
  const [isDragged, setIsDragged] = useState(false);
  const { siteId, siteName } = useParams();
  const [errors, setErrors] = useState(error);
  const [playlistOpen, setPlaylistOpen] = useState(false);
  const [tempSelectedCategory, setTempSelectedCategory] = useState([]);
  const [isModalCategoryShow, setIsModalCategoryShow] = useState(false);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [isMediaGroupDataInitialized, setIsMediaGroupDataInitialized] =
    useState(false);
  const [isAllocationModalOpen, setIsAllocationModalOpen] = useState(false);
  const [screenAllocations, setScreenAllocations] = useState([]);
  const [allocationsInitialized, setAllocationsInitialized] = useState(false);

  const {
    loading,
    userData,
    categoriesList,
    media,
    mediaGroup,
    category,
    tagList,
    poiList,
    schedulingList,
    role,
    screensList,
  } = useSelector(
    (state) => ({
      mediaList: state.media.list,
      poiList: state.pois.list,
      schedulingList: state.scheduling.list,
      loading: state.media.loading,
      userData: state.auth.userData,
      categoriesList: state.mediaCategories.list,
      tagList: state.tags.list,
      // added by me
      media: state.media.media,
      mediaGroup: state.media.mediaGroup,
      category: state.mediaCategories.mediaCategory,
      role: state.auth.userData.role,
      screensList: state.screens.list,
    }),
    shallowEqual
  );

  const uid = userData.id;
  const videoRef = useRef(null);

  const dispatch = useDispatch();

  const isGroupEdit = isEditing && media?._id === mediaGroup?._id;

  const startDate = media.start ? new Date(media.start) : undefined;
  const endDate = media.end ? new Date(media.end) : undefined;
  // const type = media.type;

  log(startDate, endDate, 'start date end date');

  useEffect(() => {
    setErrors(error);
  }, [error]);

  useEffect(() => {
    if (siteId) {
      dispatch(fetchMediaCategories({ siteId }));
      dispatch(fetchScreens({ siteId }));
    }
  }, [fetchMediaCategories]); //eslint-disable-line

  useEffect(() => {
    setAllocationsInitialized(false);
  }, [id]);

  useEffect(() => {
    if (id && media.screenIds && screensList?.length && !allocationsInitialized) {
      const initIds = media.screenIds.map((s) => (typeof s === 'string' ? s : s._id));
      const allocations = screensList.filter((s) => initIds.includes(s._id));
      if (allocations.length > 0) setScreenAllocations(allocations);
      setAllocationsInitialized(true);
    }
  }, [id, media.screenIds, screensList, allocationsInitialized]);

  const screenAllocationIds = useMemo(
    () => screenAllocations.map((s) => s._id),
    [screenAllocations]
  );

  const handleRemoveAllocation = (screenId) => {
    setScreenAllocations((prev) => prev.filter((s) => s._id !== screenId));
  };

  useEffect(() => {
    console.log(media, 'media');
    setImagePreviewUrl((prevState)=>{
      console.log(prevState, 'prevstate');
      if(!prevState){

        return media.file
          ? media.file && URL.createObjectURL(media.file)
          : media.logo && `${imgUrl}/media/${media.logo}`
      }else{
        return prevState;
      }
    }

    );
  }, [media]);

  useEffect(() => {
    const videoElement = videoRef.current;
      console.log(videoElement, videoRef, 'video element');

    if (videoElement) {
      console.log(videoElement, 'video element');
      videoElement.addEventListener('loadedmetadata', () => {
        dispatch(
          setMedia({
            ...media,
            duration:Math.floor(videoElement.duration)
          })
        );
      });
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('loadedmetadata', () => {});
      }
    };
  }, [imagePreviewUrl]);//eslint-disable-line

  const onFileChangedHandler = (file) => {
    if (
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg' ||
      file.type === 'image/gif' ||
      file.type === 'video/x-msvideo' ||
      file.type === 'video/quicktime' ||
      file.type === 'video/mp4'
    ) {
      if (file.size / 1000000 <= 300) {
        // setMedia((prevState) => ({ ...prevState, file, logo: null }));
        dispatch(
          setMedia({
            ...media,
            file,
          })
        );
        return false;
      }
      message.error('Maximum file size is 300MB');
    } else {
      message.error('Unsupported filetype!');
    }
    setIsDragged(false);
  };

  const handleDeletePreviewImage = () => {
    setMedia((prevState) => ({ ...prevState, file: null, logo: null }));
    setImagePreviewUrl(null);
  };

  const handleChange = (name, value) => {
    dispatch(
      setMedia({
        ...media,
        [name]: value,
      })
    );
  };

  const onSelectCategoryHandler = (value) => {
    // const categoryId = value.value;
    // const categoryName = value.label;

    dispatch(
      setMedia({
        ...media,
        categoryId: tempSelectedCategory,
        categoryName: categoriesList.find(
          (cat) => cat._id === tempSelectedCategory
        )?.name,
      })
    );
    setPlaylistOpen(false);
  };

  const handleChangeDate = (value) => {
    console.log(value, 'value');
    if (value) {
      dispatch(
        setMedia({
          ...media,
          start: value[0].format(),
          end: value[1].format(),
        })
      );
    } else {
      dispatch(
        setMedia({
          ...media,
          start: null,
          end: null,
        })
      );
    }
  };

  const handleSubmit = () => {
    if (
      (!regexInput(media.name) && media.name) ||
      (!isGroupEdit && !regexDescription(media.description) && media.description) ||
      media.categoryList.length < 1 ||
      (!isGroupEdit && !id && !media.file)
    ) {
      const newErrors = {
        ...errors,
        errors: {
          ...errors.errors,
        },
        message: 'Something went wrong!',
      };

      newErrors.errors.name = !regexInput(media.name) &&
        media.name && [
          {
            msg: 'This field cannot contain any special characters',
          },
        ];

      if (!id && !media.file) {
        newErrors.errors.file = [
          {
            msg: 'Upload a media',
          },
        ];
      }

      if (media.categoryList.length < 1) {
        newErrors.errors.category = [
          {
            msg: 'Must select category',
          },
        ];
      }

      newErrors.errors.description = !regexDescription(media.description) &&
        media.description && [
          {
            msg: 'This field cannot contain any special characters',
          },
        ];

      setErrors(newErrors);
    } else {
      dispatch(
        action(
          {
            uid,
            ...media,
            categoryList: media.categoryList,
            urllink: media.url,
            siteId,
            type: media.start || media.end ? 'date' : 'all',
            start: media.start && moment(media.start).format(),
            end: media.end && moment(media.end).format(),
            days: [],
            dates: [],
            screenIds: screenAllocationIds,
            // NEW — impression target (optional; omit both to skip)
            ...(media.impressionType && media.impressionCount
              ? {
                  impressionType: media.impressionType,
                  impressionCount: media.impressionCount,
                }
              : {}),
            grouped: mediaGroup?.grouped?.map((e) => {
              return {
                uid,
                id: e._id,
                ...e,
                name: media.name,
                duration: media.duration,
                categoryList: [e?.categoryId],
                urllink: media.url,
                siteId,
                type: media.start || media.end ? 'date' : 'all',
                start: media.start && moment(media.start).format(),
                end: media.end && moment(media.end).format(),
                days: [],
                dates: [],
                screenIds: screenAllocationIds,
                ...(media.file ? { file: media.file } : {}),
              };
            }),
          },
          () => history.push(`/${siteId}/information/${siteName}`)
        )
      );
    }
  };

  const handleSelectCategory = (catId) => {
    const newCat = [...tempSelectedCategory];
    const findCat = newCat.find((cat) => cat._id === catId);
    let updatedCat;
    if (findCat) {
      updatedCat = newCat.filter((cat) => cat._id !== catId);
    } else {
      updatedCat = [...tempSelectedCategory, { _id: catId }];
    }
    setTempSelectedCategory(updatedCat);
    if (isGroupEdit) {
      dispatch(
        setMedia({
          ...media,
          categoryList: _.pluck(updatedCat, '_id'),
        })
      );
    }
  };

  const handleSetCategory = () => {
    dispatch(
      setMedia({
        ...media,
        categoryList: _.pluck(tempSelectedCategory, '_id'),
      })
    );
    setPlaylistOpen(false);
  };

  // Assign value on playlist when editing media group
  useEffect(() => {
    if (media?._id === mediaGroup?._id && !isMediaGroupDataInitialized) {
      const mediaGroupCategories = mediaGroup?.grouped?.map((e) => ({
        _id: e.categoryId,
      }));
      setTempSelectedCategory(mediaGroupCategories || []);
      dispatch(
        setMedia({
          ...media,
          categoryList: _.pluck(mediaGroupCategories || [], '_id'),
        })
      );
      setTimeout(() => setIsMediaGroupDataInitialized(true), 0);
    }
  }, [media, mediaGroup, isMediaGroupDataInitialized]); // eslint-disable-line

  const getCategory = (categoryId) => {
    const findCategory = categoriesList.find((cat) => cat._id === categoryId);
    return findCategory?.name;
  };

  const handleNew = () => {
    dispatch(
      setMediaCategory({
        name: '',
        description: '',
      })
    );

    setIsModalCategoryShow(true);
  };

  const onCreate = () => {
    const action = category._id ? modifyMediaCategory : createMediaCategory;

    dispatch(
      action(
        { uid, ...category, siteId, id: category._id },
        setIsModalCategoryShow
      )
    );
  };

  const setCategory = (data) => {
    dispatch(setMediaCategory(data));
  };

  return (
    <div className="media-form">
      <ModalMediaCategoryForm
        visible={isModalCategoryShow}
        onCancel={() => {
          setIsModalCategoryShow(false);
        }}
        onCreate={onCreate}
        category={category}
        setCategory={setCategory}
        isEditing={!!category._id}
      />
      <form className="form-wrapper">
        <div>
          <div className="form">
            <label className="form-label">
              Name <span className="is-required">*</span>
            </label>
            <Input
              placeholder="Enter media's name"
              name="name"
              type="text"
              value={media.name}
              // onChange={onChangeHandler}
              onChange={(e) => handleChange('name', e.target.value)}
            />

            {/* {isDuplicate && (
              <span className="error-message">Name already exist!</span>
            )} */}

            {errors &&
              errors.errors &&
              errors.errors.name &&
              errors.errors.name.map((name, idx) => (
                <div className="error-message" key={idx}>
                  {name.msg}
                </div>
              ))}
          </div>
          <div className="form">
            <label className="form-label">
              Category <span className="is-required">*</span>
            </label>
            {isEditing && media?._id !== mediaGroup?._id ? (
              <div
                className="playlist-wrapper"
                onClick={() => setPlaylistOpen(!playlistOpen)}
              >
                <div className="playlist-selection">
                  <span>
                    {media.categoryId === 'all'
                      ? 'Show All'
                      : getCategory(media.categoryId)}
                  </span>
                </div>
                <i
                  className={`feather-chevron-down ${
                    playlistOpen ? 'playlist-open' : 'playlist-closed'
                  }`}
                />

                <CategoryDropdown
                  categories={categoriesList}
                  setTempSelectedCategory={(id) => setTempSelectedCategory(id)}
                  handleSetPlaylist={onSelectCategoryHandler}
                  tempSelectedCategory={tempSelectedCategory}
                  handleNew={handleNew}
                  modalOpen={playlistOpen}
                />
              </div>
            ) : (
              <div
                className={`playlist-wrapper ${playlistOpen ? 'active' : ''}`}
                onClick={() => setPlaylistOpen(!playlistOpen)}
              >
                <div className="playlist-selection">
                  {media.categoryList && media.categoryList.length > 0 ? (
                    <span className="playlist-value">
                      {_.pluck(
                        categoriesList.filter((cat) =>
                          media.categoryList.includes(cat._id)
                        ),
                        'name'
                      ).join(', ')}
                    </span>
                  ) : (
                    <span className="playlist-placeholder">
                      {/* {selectedCategory === 'all'
                  ? 'All Playlist'
                  : getCategory(selectedCategory)} */}
                      Select Playlist
                    </span>
                  )}
                </div>
                <i
                  className={`feather-chevron-down ${
                    playlistOpen ? 'playlist-open' : 'playlist-closed'
                  }`}
                />

                <div
                  className={`playlist-dropdown ${
                    playlistOpen
                      ? 'playlist-dropdown-open'
                      : 'playlist-dropdown-closed'
                  }`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <ul>
                    {role === 'superadmin' && (
                      <li className="header" onClick={handleNew}>
                        <i className="feather-plus" />
                        Add New Category
                      </li>
                    )}
                    {categoriesList.map((cat) => {
                      return (
                        <li key={cat._id}>
                          <div className="playlist-filter">
                            <div className="playlist-filter-radio radio-between">
                              {cat.name}
                              <div
                                className={`checkbox ${
                                  _.pluck(tempSelectedCategory, '_id').includes(
                                    cat._id
                                  )
                                    ? 'active'
                                    : ''
                                }`}
                                onClick={() => handleSelectCategory(cat._id)}
                              >
                                {_.pluck(tempSelectedCategory, '_id').includes(
                                  cat._id
                                ) && (
                                  <div className="checkbox-checked">
                                    <i className="feather-check" />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                    <li className="playlist-button" onClick={handleSetCategory}>
                      Set Playlist
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {errors &&
              errors.errors &&
              errors.errors.category &&
              errors.errors.category.map((category, idx) => (
                <div className="error-message" key={idx}>
                  {category.msg}
                </div>
              ))}
          </div>

          {!isGroupEdit && (
            <div className="form">
              <label className="form-label">Tags</label>
              <Select
                mode="multiple"
                optionLabelProp="label"
                value={media.tags || []}
                filterOption={(input, opt) =>
                  (opt?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={(e) => dispatch(setMedia({ ...media, tags: e }))}
              >
                {tagList.map((tag) => (
                  <Option key={tag._id} value={tag._id} label={tag.name}>
                    <div className="option-tag">
                      <Avatar size="small" src={`${imgUrl}/tag/${tag.logo}`} />{' '}
                      {tag.name}
                    </div>
                  </Option>
                ))}
              </Select>

              {errors && errors.errors && errors.errors.location && (
                <span className="error-message">
                  {errors.errors.location[0].msg}
                </span>
              )}
            </div>
          )}
          {!isGroupEdit && (
            <div className="form">
              <label className="form-label">Associated POI</label>
              <Select
                mode="multiple"
                optionLabelProp="label"
                filterOption={(input, opt) =>
                  (opt?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                value={media.associatedPois || []}
                onChange={(e) =>
                  dispatch(setMedia({ ...media, associatedPois: e }))
                }
              >
                {poiList.map((poi) => (
                  <Option key={poi._id} value={poi._id} label={poi.name}>
                    <div className="option-tag">
                      <Avatar size="small" src={`${imgUrl}/poi/${poi.logo}`} />{' '}
                      {poi.name}
                    </div>
                  </Option>
                ))}
              </Select>

              {errors && errors.errors && errors.errors.location && (
                <span className="error-message">
                  {errors.errors.location[0].msg}
                </span>
              )}
            </div>
          )}
          <div className="form">
            <label className="form-label">
              Duration <span className="is-required">*</span>
            </label>
            <div className="input-group">
              {/* <TimePicker
                  onChange={onDurationChangeHandler}
                  format={format}
                  value={moment(
                    `${media.duration ? media.duration : '00'}`,
                    format
                  )}
                /> */}
              <InputNumber
                size="large"
                // onChange={onDurationChangeHandler}
                disabled={
                  (media.file && media.file.type === 'video/mp4') ||
                  (media.fileType === 'video/mp4' && !media.file)
                }
                placeholder="Enter duration"
                onChange={(value) => handleChange('duration', value)}
                value={media.duration}
              />
              <div>Seconds</div>
            </div>

            {errors &&
              errors.errors &&
              errors.errors.duration &&
              errors.errors.duration.map((duration, idx) => (
                <div className="error-message" key={idx}>
                  {duration.msg}
                </div>
              ))}
          </div>

          {!isGroupEdit && (
            <div className="form">
              <label className="form-label">Impression Target</label>
              <div className="input-group impression-group" style={{ gap: 8 }}>
                <InputNumber
                  size="large"
                  min={1}
                  style={{ flex: 3, width: 'auto' }}
                  placeholder="Target number"
                  value={media.impressionCount}
                  onChange={(value) => handleChange('impressionCount', value)}
                />
                <Select
                  className='impression-type'
                  size="large"
                  style={{ flex: 1, minWidth: 0 }}
                  placeholder="Type"
                  allowClear
                  value={media.impressionType || undefined}
                  onChange={(value) => handleChange('impressionType', value)}
                >
                  <Option value="Plays" label="Plays">
                    Plays
                  </Option>
                  <Option value="Views" label="Views">
                    Views
                  </Option>
                </Select>
              </div>
            </div>
          )}

          <div className="form">
            <label className="form-label">
              Start Date / End Date <span className="is-required">*</span>
            </label>
            <div className="scheduling-group">
              <Radio.Group
                className={'radio-title'}
                onChange={(e) => handleChange('schedulingType', e.target.value)}
                value={media.schedulingType || 'manual'}
              >
                <Radio value={'list'}>Using Scheduling </Radio>
                <Radio value={'manual'}>Manual Input</Radio>
              </Radio.Group>
              {media.schedulingType === 'list' ? (
                <div>
                  <span>Scheduling</span>
                  <Select
                    mode="multiple"
                    optionLabelProp="label"
                    placeholder={'Select Schedule'}
                    filterOption={(input, opt) =>
                      (opt?.label ?? '')
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    value={media.schedulingIds || []}
                    onChange={(e) =>
                      dispatch(setMedia({ ...media, schedulingIds: e }))
                    }
                  >
                    {schedulingList.map((poi) => (
                      <Option key={poi._id} value={poi._id} label={poi.name}>
                        <div className="option-tag">{poi.name}</div>
                      </Option>
                    ))}
                  </Select>
                </div>
              ) : (
                <DatePicker.RangePicker
                  style={{ width: '100%' }}
                  className="datepicker-adsign"
                  format="DD/MM/YYYY HH:mm"
                  showTime
                  onChange={handleChangeDate}
                  value={
                    media.start && media.end
                      ? [dayjs(media.start), dayjs(media.end)]
                      : undefined
                  }
                />
              )}
            </div>
          </div>
          {/*<div className="form">*/}
          {/*  <label className="form-label">*/}
          {/*    Publish Start Date / End Date{' '}*/}
          {/*    <span className="is-required">*</span>*/}
          {/*  </label>*/}
          {/*  <DatePicker.RangePicker*/}
          {/*    style={{ width: '100%' }}*/}
          {/*    className="datepicker-adsign"*/}
          {/*    format="DD/MM/YYYY HH:mm"*/}
          {/*    showTime*/}
          {/*    onChange={handleChangeDate}*/}
          {/*    value={*/}
          {/*      media.start && media.end*/}
          {/*        ? [dayjs(media.start), dayjs(media.end)]*/}
          {/*        : undefined*/}
          {/*    }*/}
          {/*  />*/}
          {/*</div>*/}
          <div className="form">
            <div className="screen-allocation-header">
              <label className="form-label" style={{ fontWeight: 600 }}>
                Screen Allocation
              </label>
              <button
                type="button"
                className="add-allocation-link"
                onClick={() => setIsAllocationModalOpen(true)}
              >
                + Add Allocation
              </button>
            </div>
            <div className="screen-allocation">
              {screenAllocations.length === 0 ? (
                <div className="empty-state">
                  <p className="empty-text">No allocation added.</p>
                </div>
              ) : (
                screenAllocations.map((allocation) => (
                  <div key={allocation._id} className="screen-item">
                    <span className="screen-name">{allocation.name}</span>
                    <button
                      type="button"
                      className="delete-btn"
                      onClick={() => handleRemoveAllocation(allocation._id)}
                    >
                      <TrashIcon size={14} color="#CB3A31" />
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>

          {!isGroupEdit && (
            <div className="form">
              <label className="form-label">
                Event/Promotion Start and End Date
              </label>
              <Input
                placeholder="Enter Event/Promotion Start and End Date"
                name="eventSchedule"
                type="text"
                value={media.eventSchedule}
                // onChange={onChangeHandler}
                onChange={(e) => handleChange('eventSchedule', e.target.value)}
              />

              {errors &&
                errors.errors &&
                errors.errors.name &&
                errors.errors.name.map((name, idx) => (
                  <div className="error-message" key={idx}>
                    {name.msg}
                  </div>
                ))}
            </div>
          )}
        </div>
        <div>
          <div className="form">
            <label className="form-label">
              Upload <span className="is-required">*</span>
            </label>
            {imagePreviewUrl ? (
              <div className="upload-image-preview">
                <Tooltip placement="top" title="Delete">
                  <button
                    type="button"
                    onClick={handleDeletePreviewImage}
                    className="btn-remove"
                  >
                    <TrashIcon size={18} color="#CB3A31" />
                  </button>
                </Tooltip>
                {(media.file && media.file.type === 'video/mp4') ||
                (media.fileType === 'video/mp4' && !media.file) ? (
                  <video
                    ref={videoRef}
                    controls="controls"
                    key={imagePreviewUrl}
                    src={imagePreviewUrl}
                  />
                ) : (
                  <img
                    className="media-avatar"
                    src={imagePreviewUrl}
                    alt="User profile logo preview"
                  />
                )}
              </div>
            ) : (
              <Upload
                showUploadList={false}
                beforeUpload={onFileChangedHandler}
                style={{ width: '100%' }}
              >
                <div
                  onDragLeave={() => setIsDragged(false)}
                  onDragOver={() => setIsDragged(true)}
                  className={`upload-drag-and-drop ${
                    isDragged ? 'active' : ''
                  }`}
                >
                  <ExportIcon size={22} color="#C2C2C2" />
                  <p className="upload-title">
                    Drag or <span className="upload-highlight">Browse</span>
                  </p>
                  <p className="upload-subtitle">
                    File format supported: jpg, png, mp4 (Up to 50MB){' '}
                  </p>
                </div>
              </Upload>
            )}
            {errors &&
              errors.errors &&
              errors.errors.file &&
              errors.errors.file.map((file, idx) => (
                <div className="error-message" key={idx}>
                  {file.msg}
                </div>
              ))}
          </div>

          {!isGroupEdit && (
            <div className="form">
              <label className="form-label">Description </label>
              <Input.TextArea
                placeholder="Description"
                name="description"
                value={media.description}
                // onChange={onChangeHandler}
                onChange={(e) => handleChange('description', e.target.value)}
                rows={4}
              />
              {errors &&
                errors.errors &&
                errors.errors.description &&
                errors.errors.description.map((description, idx) => (
                  <div className="error-message" key={idx}>
                    {description.msg}
                  </div>
                ))}
            </div>
          )}
          {!isGroupEdit && (
            <div className="form">
              <label className="form-label">URL</label>
              <Input
                placeholder="Enter Url for Media"
                name="url"
                type="text"
                value={media.url}
                // onChange={onChangeHandler}
                onChange={(e) => handleChange('url', e.target.value)}
              />

              {errors &&
                errors.errors &&
                errors.errors.urllink &&
                errors.errors.urllink.map((name, idx) => (
                  <div className="error-message" key={idx}>
                    {name.msg}
                  </div>
                ))}
            </div>
          )}
        </div>
      </form>
      <div className="button-wrapper">
        {loading ? (
          <button type="button" disabled className="button-primary">
            Loading...
          </button>
        ) : (
          <button type="button" className="btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        )}
      </div>

      <ScreenDrawer
        open={isAllocationModalOpen}
        onClose={() => setIsAllocationModalOpen(false)}
        onSubmit={(screens) => setScreenAllocations(screens)}
        initialScreens={screenAllocationIds}
      />
    </div>
  );
}

export default MediaFormLegacy;


